import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  PRIMARY_BUTTON_BORDER,
  LIGHT_CONTAINER,
  DARK_CARDS_CONTAINER,
  DARK_BUTTON_BACKGROUND,
  LIGHT_BUTTON_BACKGROUND,
  DARK_BUTTON_BORDER,
  LIGHT_BUTTON_BORDER,
  PLAIN_ICON,
  PRIMARY_ICON,
  DARK_FIELDS_ON_CARD_MENU,
  LIGHT_MENUITEM_BACKGROUND,
} = COLORS;
export const useStyles = makeStyles((theme) =>
  createStyles({
    autoCompleteWrapper: {
      padding: 16,
      borderRadius: 8,
      '& .MuiInputBase-root': {
        backgroundColor:
          theme.palette.type === 'dark'
            ? `${DARK_FIELDS_ON_CARD_MENU} !important`
            : `${LIGHT_MENUITEM_BACKGROUND} !important`,
        borderRadius: 6,
        paddingRight: 10,
      },
    },

    root: {
      display: 'flex',
      gap: 30,

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },

      [theme.breakpoints.down('xs')]: {
        gap: 10,
      },
    },
    content: {
      width: '100%',
      height: '100%',
      borderRadius: 8,
      border: '1px solid',
      borderColor: theme.palette.type === 'dark' ? DARK_CARDS_CONTAINER : LIGHT_CONTAINER,
      background: theme.palette.type === 'dark' ? DARK_CARDS_CONTAINER : LIGHT_CONTAINER,
    },
    tabContainer: {
      minWidth: 240,

      '& .MuiTabScrollButton-root': {
        width: 20,
      },
      '& .MuiTabs-indicator': {
        display: 'none',
      },

      [theme.breakpoints.down('md')]: {
        '& .MuiTabs-flexContainer': {
          flexDirection: 'unset',
          gap: 20,
          minWidth: 'unset',
        },
      },
      [theme.breakpoints.down('xs')]: {
        '& .MuiTabs-flexContainer': {
          gap: 20,
        },
      },
    },
    tabItem: {
      background: theme.palette.type === 'dark' ? DARK_BUTTON_BACKGROUND : LIGHT_BUTTON_BACKGROUND,
      width: '100%',
      marginBottom: 10,
      borderRadius: 8,
      border: '1px solid',
      borderColor: theme.palette.type === 'dark' ? DARK_BUTTON_BORDER : LIGHT_BUTTON_BORDER,
      opacity: 0.6,
      minHeight: 'unset',
      height: 55,
      padding: '10px 20px',

      '&.Mui-disabled': {
        opacity: '0.25!important',
        '& svg path': {
          fill: theme.palette.type === 'dark' ? PLAIN_ICON : PRIMARY_ICON,
          opacity: 0.6,
        },
      },

      '& .MuiSvgIcon-root ': {
        marginRight: 20,
        marginBottom: '0!important',
        [theme.breakpoints.down('xs')]: {
          marginRight: 0,
          height: '30px',
          width: '30px',
          marginTop: 4,
        },

        '&.account': {
          width: 24,
        },
        '&.briefcase': {
          width: 23,
        },
        '&.padlock': {
          width: 18,
        },
        '&.logo': {
          width: 24,
        },
        '&.billing': {
          width: 18,
        },
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'unset',
        justifyContent: 'unset',
      },

      '&.Mui-selected': {
        borderColor: PRIMARY_BUTTON_BORDER,
      },

      [theme.breakpoints.down('xs')]: {
        width: 100,
        minWidth: 'unset',
        height: 90,

        '& .MuiTab-wrapper': {
          flexDirection: 'column',
          justifyContent: 'center',
          lineHeight: 1.2,
          marginTop: -5,
          fontSize: 12,
        },
      },
    },

    autoCompleteClearIndicator: {
      visibility: 'visible',
    },

    removeOutline: {
      '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
          border:
            theme.palette.type === 'dark' ? `1px solid ${DARK_BUTTON_BORDER}` : `1px solid ${LIGHT_BUTTON_BORDER}`,
          outline: 'none',
        },
      },
    },
  }),
);
